import { Controller } from "@hotwired/stimulus"
import * as ajax from "../common/utils/ajax"

export default class extends Controller {
  static values = {
    url: String
  }
  static targets = ["description"]
  static classes = ["hidden"]

  async connect() {
    // docs: https://status.swish.nu/api#incidents-unresolved
    const response = await ajax.get(this.urlValue)
    if(response.incidents[0]) {
      this.element.classList.remove(this.hiddenClass)
      this.descriptionTarget.textContent = response.incidents[0].name
    }
  }
}
